<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col>
          <b-link @click="goBack">
            <font-awesome-icon :icon="['far', 'chevron-left']" size="lg" />
            <span class="pl-2">Regresar</span>
          </b-link>
        </b-col>
      </b-row>
      <b-row align-h="center">
        <b-col sm="10">
          <div class="step-header">
            <span class="step-title">SELECCIONAR COLOR</span>
          </div>
        </b-col>
      </b-row>

      <b-row align-h="center">
        <b-col cols="10">
          <div class="d-flex justify-content-center">
            <div class="mr-5">
              <b-button-group>
                <b-button :variant="typeSelected === 'Liso' ? 'secondary' : 'outline-secondary'" :disabled="loading" @click="selectType('Liso')">
                  Liso
                </b-button>
                <b-button
                  v-if="submital.configurable_type !== 'Configurator::Cortina'"
                  :variant="typeSelected === 'Jaspe' ? 'secondary' : 'outline-secondary'"
                  :disabled="loading"
                  @click="selectType('Jaspe')"
                >
                  Jaspe
                </b-button>
                <b-button
                  v-if="submital.configurable_type === 'Configurator::PuertaAutomatica'"
                  :variant="typeSelected === 'Puerta' ? 'secondary' : 'outline-secondary'"
                  :disabled="loading"
                  @click="selectType('Puerta')"
                >
                  Puerta
                </b-button>
              </b-button-group>
            </div>

            <div class="mr-4">
              <b-button-group>
                <b-button :variant="finishedSelected === 'Mate' ? 'secondary' : 'outline-secondary'" :disabled="loading" @click="selectFinished('Mate')">
                  Mate
                </b-button>
                <b-button :variant="finishedSelected === 'Satinado' ? 'secondary' : 'outline-secondary'" :disabled="loading" @click="selectFinished('Satinado')">
                  Satinado
                </b-button>
              </b-button-group>
            </div>
          </div>
        </b-col>
      </b-row>

      <b-row align-h="center" class="my-5">
        <b-col cols="10">
          <b-row v-if="loading" align-h="center">
            <div class="text-center text-info mt-5 fs-18">
              <b-spinner small type="grow"></b-spinner>
              <span class="pl-2">Cargando...</span>
            </div>
          </b-row>
          <b-row v-else align-h="center">
            <b-col
              cols="4"
              lg="2"
              v-for="color in filteredColors" :key="color.id"
            >
              <div
                class="color-thumbnail align-self-center"
                @click="openDetailModal(color)"
              >
                <div class="color-thumbnail-text rounded-top" style="border-bottom: 1px solid black;">
                  <font-awesome-icon v-show="color.id === assignedColor.id" :icon="['fas', 'check-circle']" size="lg" fixed-width class="float-right text-success" />
                  <span v-if="['Liso', 'Puerta'].includes(color.tipo_color)" class="font-weight-bold">#{{ color.ral_code }}</span><br>
                  <span>{{ color.tipo_acabado }}</span>
                </div>
                <div v-if="['Liso', 'Puerta'].includes(color.tipo_color)">
                  <div class="color-sample-hex-thumb" :style="{ 'background-color': '#' + color.hex_code }" />
                </div>
                <div v-else>
                  <img :src="getColorImg(color)" :alt="color.name" style="height: 80px; width: 118px;"/>
                </div>
                <div class="color-thumbnail-text text-center" style="border-top: 1px solid black;">
                  <span>{{ color.name }}</span><br>
                </div>
              </div>
            </b-col>
            <b-col v-if="filteredColors.length === 0">
              <div class="d-flex justify-content-center">
                <div class="text-center text-secondary mt-5 fs-18">
                  No hay colores disponibles del tipo <b>{{ typeSelected }}</b> y acabado <b>{{ finishedSelected }}</b>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>

    <b-modal
      v-model="detailModalShow"
      hide-footer
      @show="fetchSelectedColorSamples"
      @hide="clearModal"
    >
      <template #modal-header>
        <span v-if="selectedColor" class="configurator-label">
          {{ selectedColor.name }}
        </span>

      </template>
      <b-container v-if="selectedColor" fluid>
        <b-row align-h="center" class="mb-2">
          <Button variant="green" @click="updateColor">
            Seleccionar
          </Button>
        </b-row>
        <b-row v-if="selectedColor.name.toLowerCase().includes('especial')" class="my-2">
          <b-col>
            <b-link href="http://www.ralcolor.com/" target="_blank">
              RAL Chart
            </b-link>
          </b-col>
        </b-row>
        <div v-if="selectedColorSamples.length > 0" class="d-flex justify-content-center flex-column">
          <p class="configurator-label">Imágenes de referencia:</p>
          <div v-for="color in selectedColorSamples" :key="color.id"  class="d-flex justify-content-center mb-1">
            <b-img :src="color.image_url" :alt="selectedColor.name" style="object-fit: contain; object-position: center;" />
          </div>
        </div>
        <div v-else class="d-flex justify-content-center">
          <div class="text-center text-secondary my-3 fs-18">
            <span v-if="processing">Cargando</span>
            <span v-else>No hay imágenes de referencia disponibles</span>
          </div>
        </div>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Button from '../../shared/Button'

import jaspem21 from '../../../../../public/images/colors/JASPEM2-1.png'
import jaspem22 from '../../../../../public/images/colors/JASPEM2-2.png'
import jaspem23 from '../../../../../public/images/colors/JASPEM2-3.png'
import jaspem24 from '../../../../../public/images/colors/JASPEM2-4.png'
import missingImg from '../../../../../public/images/original/missing.png'

export default {
  name: 'ColorSelector',
  components: { Button },
  data () {
    return {
      loading: false,
      typeSelected: 'Liso',
      finishedSelected: 'Satinado',
      colors: [],
      selectedColor: null,
      selectedColorSamples: [],
      detailModalShow: false,
      processing: false,
      colorImgs: {
        'JASPEM2-1': jaspem21,
        'JASPEM2-2': jaspem22,
        'JASPEM2-3': jaspem23,
        'JASPEM2-4': jaspem24
      },
      missingImage: missingImg
    }
  },
  computed: {
    ...mapState ({ submital: state => state.configurator.submital }),
    ...mapGetters (['configurableId', 'configurableType', 'configurableTypeUrlString', 'isCortina', 'assignedColor']),
    filteredColors () {
      return this.colors
    },
  },
  mounted () {
    this.fetchColors()
  },
  methods: {
    fetchColors () {
      this.loading = true
      this.$http.get(`/api/production/submitals/${this.submital.id}/colors`,
        { params: { tipo_color: this.typeSelected, tipo_acabado: this.finishedSelected } }
      )
        .then((res) => {
          this.colors = res.data
        })
        .catch(e => console.log(e))
        .finally(() => this.loading = false)
    },
    updateColor () {
      if (this.processing) { return }
      this.processing = true
      let mod = this.configurableType.toLowerCase()
      if (this.configurableTypeUrlString === 'puertas_automaticas') {
        mod = 'automatic_door'
      }
      this.$http.patch(`/api/production/submitals/${this.submital.id}/${this.configurableTypeUrlString}/${this.configurableId}`, {
        [mod]: {
          color_id: this.selectedColor.id
        }
      })
        .then((res) => {
          // console.log(res.data)
          this.$store.commit('setConfigurable', res.data)
          this.detailModalShow = false
          this.goBack()
        })
        .catch(e => console.log(e))
        .finally(this.processing = false)
    },
    selectType (type) {
      this.typeSelected = type
      this.fetchColors()
    },
    selectFinished (finished) {
      this.finishedSelected = finished
      this.fetchColors()
    },
    getColorImg (color) {
      if (!color.id || ['Liso', 'Puerta'].includes(color.tipo_color)) { return this.missingImage }
      const name = color.name.toUpperCase().split(' ')[0]

      const image = this.colorImgs[name]
      return image ? image : this.missingImage
    },
    openDetailModal (color) {
      this.selectedColor = color
      this.detailModalShow = true
    },
    fetchSelectedColorSamples () {
      if (this.processing) { return }
      this.processing = true
      this.$http.get(`/api/production/submitals/${this.submital.id}/colors/${this.selectedColor.id}/samples`)
        .then((res) => {
          // console.log(res.data)
          this.selectedColorSamples = res.data
        })
        .catch(e => console.log(e))
        .finally(this.processing = false)
    },
    clearModal () {
      this.selectedColor = null
      this.selectedColorSamples = []
    },
    goBack () {
      if (this.configurableType === 'PuertaAutomatica') {
        this.$store.commit('setCurrentStep', 'general')
        return
      }
      this.$store.commit('setCurrentStep', 'design')
    }
  }
}
</script>
